import React, { useEffect, useState } from "react";
import "../css/user-management.css";

// ✅ Normalize API base just like Dashboard
const RAW_API_BASE =
  (typeof import.meta !== "undefined" ? import.meta.env?.VITE_API_BASE : undefined) ||
  process.env.REACT_APP_API_BASE ||
  "https://pos-backend-58o9.onrender.com";

const API_BASE = RAW_API_BASE.replace(/\/+$/, "").replace(/\/api$/i, "");

// ✅ Universal helper
const apiPath = (path) => `${API_BASE}${path.startsWith("/api") ? path : `/api${path}`}`;

const getAuth = () => {
  const raw = localStorage.getItem("rcs_auth") || sessionStorage.getItem("rcs_auth");
  try { return raw ? JSON.parse(raw) : null; } catch { return null; }
};
const authHeader = () => {
  const s = getAuth();
  return s?.access_token ? { Authorization: `Bearer ${s.access_token}` } : {};
};
const asJson = (r) => (r.ok ? r.json() : r.json().catch(()=>({})).then(e=>Promise.reject(e)));

const api = {
  listUsers: () => fetch(apiPath("/users"), { headers: { "Content-Type":"application/json", ...authHeader() } }).then(asJson),
  createUser: (payload) => fetch(apiPath("/users"), { method:"POST", headers:{ "Content-Type":"application/json", ...authHeader() }, body: JSON.stringify(payload) }).then(asJson),
  setStatus: (id, status) => fetch(apiPath(`/users/${id}/status`), { method:"PATCH", headers:{ "Content-Type":"application/json", ...authHeader() }, body: JSON.stringify({ status }) }).then(asJson),
  resetPassword: (id, newPassword) => fetch(apiPath(`/users/${id}/password`), { method:"PATCH", headers:{ "Content-Type":"application/json", ...authHeader() }, body: JSON.stringify({ newPassword }) }).then(asJson),
};


export default function UserManagement() {
  const [users, setUsers] = useState([]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [form, setForm] = useState({ name: "", email: "", password: "" });

  const load = async () => {
    setBusy(true); setErr("");
    try { setUsers(await api.listUsers()); }
    catch (e) { setErr(e.message || e.error || "Failed to load users"); }
    finally { setBusy(false); }
  };
  useEffect(() => { load(); }, []);

  const onCreate = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await api.createUser({ ...form, role: "user" });

      setForm({ name: "", email: "", password: "" });
      await load();
    } catch (e) {
      setErr(e.message || e.error || "Failed to create user");
    } finally { setBusy(false); }
  };

  const onToggle = async (u) => {
    setErr(""); setBusy(true);
    try { await api.setStatus(u.id, !u.status); await load(); }
    catch (e) { setErr(e.message || e.error || "Failed to update status"); }
    finally { setBusy(false); }
  };

  const onReset = async (u) => {
    const pw = window.prompt(`Enter a new password for ${u.email}`);
    if (!pw) return;
    setErr(""); setBusy(true);
    try { await api.resetPassword(u.id, pw); alert("Password updated"); }
    catch (e) { alert(e.message || e.error || "Failed to update password"); }
    finally { setBusy(false); }
  };

  return (
    <div className="user-management-container">
    <div className="um">
      <h2>User Management</h2>

      {err && <div className="um-alert">{err}</div>}

      <div className="um-card">
        {/* Create cashier form */}
        <form className="um-form" onSubmit={onCreate}>
          <input
            className="um-input"
            placeholder="Full name"
            value={form.name}
            onChange={(e)=>setForm(f=>({ ...f, name: e.target.value }))}
            required
          />
          <input
            className="um-input"
            type="email"
            placeholder="Email"
            value={form.email}
            onChange={(e)=>setForm(f=>({ ...f, email: e.target.value }))}
            required
          />
          <input
            className="um-input"
            type="password"
            placeholder="Temp password"
            value={form.password}
            onChange={(e)=>setForm(f=>({ ...f, password: e.target.value }))}
            required
          />
          <div className="um-actions">
            <button className="btn btn-primary" disabled={busy}>Add Cashier</button>
          </div>
        </form>

        {/* Table */}
        <div className="um-table-wrap">
          <table className="um-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Status</th>
                <th style={{ textAlign:"center" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id}>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td>{u.role}</td>
                  <td>
                    <span className={`badge ${u.status ? "active" : "inactive"}`}>
                      {u.status ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td style={{ textAlign:"center" }}>
                    <div className="row-actions">
                      <button className="btn btn-ghost btn-sm" onClick={()=>onToggle(u)} disabled={busy}>
                        {u.status ? "Deactivate" : "Activate"}
                      </button>
                      <button className="btn btn-ghost btn-sm" onClick={()=>onReset(u)} disabled={busy}>
                        Reset PW
                      </button>
                    </div>
                  </td>
                </tr>
              ))}

              {!users.length && (
                <tr>
                  <td colSpan={5} style={{ textAlign:"center", color:"var(--muted)" }}>
                    {busy ? <span className="skel" style={{ width: 120 }} /> : "No users yet"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
  );
}
